// extracted by mini-css-extract-plugin
module.exports = {"instagramWrapper":"Iq-z","innerTile":"Jq-z","heading":"Kq-z","instaTileBtn":"Lq-z","disabled":"Mq-z","instaTileElement":"Nq-z","instagramPic":"Oq-z"};